module.exports = __webpack_public_path__ + "img/97.493f1ca6.jpg";